export const pollJobUntilDone = async ({
  getStatus,
  interval = 6000,
  timeout = 600000,
}) => {
  const start = Date.now();

  while (true) {
    const { result } = await getStatus();
    const state = result?.state;

    if (["COMPLETED", "SUCCEEDED", "SUCCESS"].includes(state)) {
      return result;
    }

    if (["FAILED", "ERROR"].includes(state)) {
      throw new Error(result?.data?.error ?? "Job failed");
    }

    if (Date.now() - start > timeout) {
      throw new Error("Job timeout");
    }

    await new Promise((r) => setTimeout(r, interval));
  }
};